module.exports = __webpack_public_path__ + "img/CSLHSC-5.36ee808f.png";